import config from '../../config';

// SLING-791: shared CDN resize URL construction (replaces per-file inline
// string building). Extracts the S3 key from any of the URL forms the server
// may return:
//   https://slinging(-staging).s3.amazonaws.com/<key>
//   https://slinging(-staging).s3.us-east-1.amazonaws.com/<key>
//   https://(test-)uploads.getsling.com/<key>  (CloudFront distribution)
// and rewrites it as a resize URL on the environment's uploads host, where
// the Lambda@Edge function resizes on cache miss. Non-S3 URLs (external
// images) are returned unchanged.
const S3_PATTERNS = [
  /^https?:\/\/slinging(?:-staging)?\.s3(?:\.[^.]+)?\.amazonaws\.com\/(.+)/,
  /^https?:\/\/(?:test-)?uploads\.getsling\.com\/(.+)/,
];

export default function cdnResizeUrl(url, width, height, fit = 'cover') {
  let key = null;
  for (const pattern of S3_PATTERNS) {
    const m = url.match(pattern);
    if (m) {
      key = m[1];
      break;
    }
  }
  if (!key) {
    return url;
  }
  // Strip any existing query string from the key before appending resize params
  const keyBase = key.split('?')[0];
  return `https://${config.SLING_UPLOADS}/${keyBase}?w=${width}&h=${height}&fit=${fit}&fmt=jpeg`;
}
